module.exports = __webpack_public_path__ + "img/h_02.9aef0632.jpg";